(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["header-with-image"] && !Shopify.designMode) return;
  try {
    function initHoverImageSections() {
    document.querySelectorAll('.shopify-section').forEach((section) => {
      if (section._hoverImageInit) return;

      const blocks = [...section.querySelectorAll('[data-hover-image]')];
      if (!blocks.length) return;

      const imageEl = section.querySelector('.image-block img');
      if (!imageEl) return;

      section._hoverImageInit = true;

      const originalSrc = imageEl.getAttribute('src');
      const originalSrcset = imageEl.getAttribute('srcset');

      blocks.forEach((block) => {
        block.addEventListener('mouseenter', () => {
          imageEl.setAttribute('src', block.dataset.hoverImage);
          imageEl.setAttribute('srcset', block.dataset.hoverSrcset);
          blocks.forEach((b) => {
            b.style.opacity = b === block ? '' : '0.4';
          });
        });
      });

      section.addEventListener('mouseleave', () => {
        imageEl.setAttribute('src', originalSrc);
        imageEl.setAttribute('srcset', originalSrcset);
        blocks.forEach((b) => {
          b.style.opacity = '';
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverImageSections);
  } else {
    initHoverImageSections();
  }

  document.addEventListener('shopify:section:load', initHoverImageSections);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    class ProductSwatchesComponent extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => this.handleSwatchClick(event));
    }

    handleSwatchClick(event) {
      const item = event.target.closest('[data-option-value]');
      if (!item) return;

      if (item.dataset.optionAvailable === 'false') return;

      // Prevent triggering on carousel arrow buttons
      if (event.target.closest('.slideshow-control')) return;

      const productCard = this.closest('product-card');
      if (!productCard) return;

      const quickAdd = productCard.querySelector('quick-add-component');
      if (!quickAdd || typeof quickAdd.handleClick !== 'function') return;

      // Read the variant ID baked into the swatch item by Liquid — this works
      // even when swatches-variant-picker-component is not present on the card.
      const variantId = item.dataset.variantId;
      if (variantId) {
        // The card link already has ?variant=DEFAULT_ID. QuickAddComponent.productPageUrl
        // returns early when it sees that param, ignoring the clicked swatch.
        // Update the href to the correct variant before handleClick reads it.
        const productCardLink =
          typeof productCard.getProductCardLink === 'function'
            ? productCard.getProductCardLink()
            : productCard.querySelector('a.product-card__link');
        if (productCardLink instanceof HTMLAnchorElement) {
          const updatedUrl = new URL(productCardLink.href);
          updatedUrl.searchParams.set('variant', variantId);
          productCardLink.href = updatedUrl.toString();
        }
      }

      // Also check the matching radio in swatches-variant-picker-component if present,
      // so #syncVariantSelection in QuickAddComponent can do its job.
      const optionValue = item.dataset.optionValue;
      if (optionValue) {
        const allRadios = productCard.querySelectorAll(
          'swatches-variant-picker-component input[type="radio"]'
        );
        const radio = Array.from(allRadios).find(
          (r) => r instanceof HTMLInputElement && r.value === optionValue
        );
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      quickAdd.handleClick(event);
    }
  }

  if (!customElements.get('product-swatches-component')) {
    customElements.define('product-swatches-component', ProductSwatchesComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
